interface Sound {
  url: string;
  buffer?: AudioBuffer;
  volume?: number;
}

const sounds: Record<string, Sound> = {
  profit: {
    url: "sounds/profit3.mp3",
  },
  loss: {
    url: "sounds/enough.mp3",
  },
  fresh: {
    url: "sounds/fresh.mp3",
  },
  trend: {
    url: "sounds/trend.mp3",
  },
};

const soundContext = new AudioContext();

for (const key in sounds) {
  loadSound(key);
}

function shouldPlaySound(): boolean {
  const soundNotification = document.getElementById(
    "soundNotification"
  ) as HTMLInputElement;
  let playSounds = true;
  if (soundNotification === null) {
    playSounds = true;
  } else {
    playSounds = soundNotification.checked;
  }
  return playSounds;
}

async function loadSound(name: string): Promise<void> {
  const sound = sounds[name];
  const url = sound.url;

  try {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();

    await soundContext.decodeAudioData(arrayBuffer, (newBuffer) => {
      sound.buffer = newBuffer;
    });
  } catch (error) {
    console.error(`Error loading sound "${name}":`, error);
    sound.buffer = undefined;
  }
}

function playSound(name: string, options?: { volume?: number }): void {
  if (shouldPlaySound()) {
    const sound = sounds[name];
    const soundVolume = sound.volume || 0.5;

    const buffer = sound.buffer;
    if (buffer) {
      const source = soundContext.createBufferSource();
      source.buffer = buffer;

      const volume = soundContext.createGain();
      volume.gain.value =
        options && options.volume ? soundVolume * options.volume : soundVolume;

      volume.connect(soundContext.destination);
      source.connect(volume);
      source.start(0);
    }
  }
}

export default playSound;
